import { render } from "./ManageService.vue?vue&type=template&id=5dfe6254"
import script from "./ManageService.vue?vue&type=script&lang=js"
export * from "./ManageService.vue?vue&type=script&lang=js"

import "./ManageService.vue?vue&type=style&index=0&id=5dfe6254&lang=css"

import exportComponent from "C:\\Users\\alida\\Desktop\\jupyto\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__